export default __webpack_public_path__ + "static/media/ZA_profile.f8426997.jpg";